import keymirror from 'keymirror';

export default keymirror({
  none: null,
  number: null,
  phone: null,
  email: null,
});
